var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code c_code",staticStyle:{"max-height":"unset"}},[_vm._v(_vm._s(_vm.stats))])}
var staticRenderFns = []

export { render, staticRenderFns }